export default __webpack_public_path__ + "static/media/logo_sm_white.6ae8601e.svg";